import { render, staticRenderFns } from "./SatisfacaoUnidades.vue?vue&type=template&id=8a6713a6&scoped=true"
import script from "./SatisfacaoUnidades.vue?vue&type=script&lang=js"
export * from "./SatisfacaoUnidades.vue?vue&type=script&lang=js"
import style0 from "./SatisfacaoUnidades.vue?vue&type=style&index=0&id=8a6713a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a6713a6",
  null
  
)

export default component.exports